import { gql } from '@apollo/client';

export const typeDefs = gql`
  type Query {
    workSessionsState: StoredWorkSessionsState!
  }

  type Mutation {
    updateWorkSessionsState(newState: StoredWorkSessionsStateInput!): StoredWorkSessionsState!
  }

  input StoredWorkSessionsStateInput {
    currentSession: Int!
    sessionTimePassedSeconds: Float!
    playTimestamp: Float
  }

  type StoredWorkSessionsState {
    currentSession: Int!
    sessionTimePassedSeconds: Float!
    playTimestamp: Float
  }
`;
